"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _reactRedux = require("react-redux");

var _redial = require("redial");

var _assetDownloads = require("redux/modules/assetDownloads");

var assetDownloadActions = _interopRequireWildcard(_assetDownloads);

var _assets = require("redux/modules/assets");

var _AssetPopup = require("@quixeltools/quixel-ui-library/dist/components/megascans/library/AssetPopup");

var _AssetPopup2 = _interopRequireDefault(_AssetPopup);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _TextButtonWithIcon = require("@quixeltools/quixel-ui-library/dist/components/common/website/TextButtonWithIcon");

var _TextButtonWithIcon2 = _interopRequireDefault(_TextButtonWithIcon);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _components = require("components");

var _utils = require("utils");

var _utils2 = require("../../EpicMigration/utils");

var _glamor = require("glamor");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var loadingSpinnerStyles = (0, _glamor.css)({
  margin: "0",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  "& span": {
    width: "40px",
    height: "40px",
    border: "2px solid transparent",
    borderLeftColor: "gray"
  }
});
var title = (0, _glamor.css)(_fonts.p6, {
  color: _css.pallets.white
});

var toolTipContainer = (0, _glamor.css)({
  display: "flex",
  flexDirection: "column",
  width: "274px"
}, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
  width: "248px"
}));
var subContainer = (0, _glamor.css)({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: "21px"
});
var links = (0, _glamor.css)(_fonts.p3, {
  maxWidth: "241px",
  float: "left",
  "& a": {
    letterSpacing: "-0.5px!important",
    padding: 0,
    lineHeight: "1.38",
    fontWeight: "400!important",
    textTransform: "capitalize",
    paddingLeft: "0",
    marginLeft: "-1px"
  },
  "& button": {
    letterSpacing: "-0.5px!important",
    padding: 0,
    lineHeight: "1.38",
    fontWeight: "400!important",
    textTransform: "capitalize",
    paddingLeft: "0",
    marginLeft: "-1px"
  }
}, (0, _css.minWidth)(_css.breakpoints.xxlarge)({
  "& a": {
    lineHeight: "1.1"
  },
  "& button": {
    lineHeight: "1.1"
  }
}));

var AssetPopupContainer = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params;
    var id = params.asset;

    var state = getState();
    var asset = null;
    if (state && state.assets && state.assets.fullAssets && state.assets.fullAssets.find) {
      asset = state.assets.fullAssets.find(function (a) {
        return a.id === id;
      });
    }
    if (asset) {
      return dispatch(function () {});
    }
    if (!(0, _assets.hasFullAsset)(getState(), id)) {
      return dispatch((0, _assets.loadFullAsset)(id));
    }
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    fullAssets: state.assets.fullAssets,
    algoliaAssets: state.assets.assets,
    user: state.user,
    freeAssetDrops: state.assets.freeAssetDrops,
    settings: state.settings,
    loggedIn: state.auth.loggedIn,
    downloadRequesting: state.assetDownloads.downloadRequesting,
    acquiringAsset: state.assetDownloads.acquiringAsset,
    favorites: state.assets.favorites
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(AssetPopupContainer, _React$Component);

  function AssetPopupContainer(props) {
    (0, _classCallCheck3.default)(this, AssetPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AssetPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(AssetPopupContainer)).call(this, props));

    _this.state = {
      isOpen: false,
      toolTipCount: 0,
      platform: "Windows"
    };

    _this.onShowDetailsClick = _this.onShowDetailsClick.bind(_this);
    _this.onHideDetailsClick = _this.onHideDetailsClick.bind(_this);

    _this.handleAcquireClick = _this.handleAcquireClick.bind(_this);
    _this.handleDownloadClick = _this.handleDownloadClick.bind(_this);
    _this.handleSettingsClick = _this.handleSettingsClick.bind(_this);
    _this.handleFavoriteToggle = _this.handleFavoriteToggle.bind(_this);
    _this.onToolTipClickHandler = _this.onToolTipClickHandler.bind(_this);
    _this.manufactureManage = _this.manufactureManage.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AssetPopupContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "handleFavoriteToggle",
    value: function handleFavoriteToggle(id, favorited) {
      // const { addToFavorites, removeFromFavorites } = this.props;
      var dispatch = this.props.dispatch;


      if (favorited) {
        dispatch((0, _assets.removeFromFavorites)(id));
      } else {
        dispatch((0, _assets.addToFavorites)(id));
      }
    }
  }, {
    key: "handleAcquireClick",
    value: function handleAcquireClick() {
      var _props = this.props,
          user = _props.user,
          params = _props.params,
          assets = _props.assets,
          fullAssets = _props.fullAssets,
          dispatch = _props.dispatch;


      if (!user.subscription) {
        // Display login in a popup
        this.context.router.push("/login");
        return;
      }

      var assetId = params.asset;

      var asset = fullAssets[assetId] || assets && assets.find && assets.find(function (a) {
        return a.id === assetId;
      });

      dispatch(assetDownloadActions.acquireAsset({
        assetId: assetId,
        resolution: user.subscription.accessResolution,
        cost: asset.points || 1,
        exrAccess: user.subscription.exrAccess
      })).then(this.handleDownloadClick);
    }
  }, {
    key: "handleDownloadClick",
    value: function handleDownloadClick() {
      var _this2 = this;

      var _props2 = this.props,
          params = _props2.params,
          fullAssets = _props2.fullAssets,
          assets = _props2.assets,
          dispatch = _props2.dispatch,
          loggedIn = _props2.loggedIn,
          user = _props2.user;
      var assetId = params.asset;

      var asset = fullAssets[assetId];
      var isFullAssetLoaded = !!fullAssets[assetId];

      if (!isFullAssetLoaded) return;

      // Allow free assets only for subscribers
      if (!asset.acl && asset.points === 0) {
        var subscribed = (0, _utils.isActiveSubscriber)(user);

        if (!subscribed) {
          var megascansTrial = user.megascansTrial;

          if (_underscore2.default.isEmpty(megascansTrial)) {
            return this.context.dialogs.custom(_react2.default.createElement(_components.TrialPopup, null));
          } else {
            if (!(0, _utils.isActiveSubscriber)(user)) return this.context.dialogs.custom(_react2.default.createElement(_components.TrialPopup, { trailExpired: true }));
          }
        }
      }

      dispatch(assetDownloadActions.requestAssetDownload({
        assetId: assetId,
        asset: asset,
        isFree: asset.points === 0
      })).catch(function (e) {
        if (e.code === "DOWNLOAD_LIMIT_REACHED") {
          _this2.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
            title: "Download limit reached",
            description: "You have exceeded your download limit for this particular asset. Please let us know if you're experiencing problems downloading this asset.",
            tag: "Download Exceeded",
            initialValues: {
              name: "",
              email: loggedIn ? user.email : "",
              subject: assetId,
              comment: ""
            }
          }));
        }
      });

      this.onToolTipClickHandler();
    }
  }, {
    key: "onPresetChange",
    value: function onPresetChange() {}
  }, {
    key: "onToolTipClickHandler",
    value: function onToolTipClickHandler() {
      var tooltipCount = window.localStorage.getItem("tooltipCount");

      if (tooltipCount) {
        if (parseInt(tooltipCount) < 6) {
          window.localStorage.setItem("tooltipCount", parseInt(tooltipCount) + 1);
          this.setState({
            toolTipCount: parseInt(tooltipCount) + 1
          });
        } else {
          window.localStorage.setItem("tooltipCount", 0);
          this.setState({
            toolTipCount: 0
          });
        }
      } else {
        window.localStorage.setItem("tooltipCount", 0);
        this.setState({
          toolTipCount: 0
        });
      }
    }
  }, {
    key: "handleSettingsClick",
    value: function handleSettingsClick() {
      var dialogs = this.context.dialogs;
      var _props3 = this.props,
          params = _props3.params,
          assets = _props3.assets,
          fullAssets = _props3.fullAssets,
          settings = _props3.settings;
      var assetId = params.asset;


      var asset = fullAssets[assetId] || assets && assets.find && assets.find(function (a) {
        return a.id === assetId;
      });
      var isFullAssetLoaded = !!fullAssets[assetId];

      if (!isFullAssetLoaded) return;

      var type = asset.categories[0];
      var initialValues = asset.version === 2 && type.toLowerCase().startsWith("3d") ? settings["3dplant"] : settings[type];

      dialogs.custom(_react2.default.createElement(_components.DownloadSettingsPopup, { asset: asset, initialValues: initialValues }));
    }
  }, {
    key: "manufactureManage",
    value: function manufactureManage() {
      var _props4 = this.props,
          params = _props4.params,
          fullAssets = _props4.fullAssets;
      var assetId = params.asset;


      var asset = fullAssets[assetId];
      var manufacturer = asset.manufacturer;
      var dialogs = this.context.dialogs;


      dialogs.custom(_react2.default.createElement(_components.ManufacturerManageContainer, {
        assetId: assetId,
        assetTitle: "Update " + manufacturer.name + " Asset",
        manufacturerTitle: "Update " + manufacturer.name + " Details",
        initialValues: {
          assetName: asset.name,
          removeAsset: "false",

          manufacturerName: manufacturer.name
        }
      }));
    }
  }, {
    key: "onShowDetailsClick",
    value: function onShowDetailsClick() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "onHideDetailsClick",
    value: function onHideDetailsClick() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _React$createElement;

      var _props5 = this.props,
          params = _props5.params,
          fullAssets = _props5.fullAssets,
          algoliaAssets = _props5.algoliaAssets,
          user = _props5.user,
          dispatch = _props5.dispatch,
          settings = _props5.settings,
          loggedIn = _props5.loggedIn,
          childReference = _props5.childReference,
          downloadRequesting = _props5.downloadRequesting,
          favorites = _props5.favorites,
          freeAssetDrops = _props5.freeAssetDrops;
      var assetId = params.asset,
          manage = params.manage;


      var asset = fullAssets[assetId];
      var _asset = asset,
          manufacturer = _asset.manufacturer;

      if (manufacturer) {
        if (manufacturer.logo.indexOf("http://cdn.quixel.com/") === -1) {
          manufacturer.logo = "http://cdn.quixel.com/" + manufacturer.logo;
        }
        if (manufacturer.companyLink.indexOf("http") === -1) {
          manufacturer.companyLink = "https://" + manufacturer.companyLink;
        }
      }
      var _asset2 = asset,
          isLoggedInUserAnAssetManufacturer = _asset2.isLoggedInUserAnAssetManufacturer;

      var aAssets = algoliaAssets && algoliaAssets.toArray && algoliaAssets.toArray();
      var algoliaAsset = aAssets && aAssets.find && aAssets.find(function (a) {
        return a.id === assetId;
      });
      if (!algoliaAsset) {
        algoliaAsset = freeAssetDrops && freeAssetDrops.find && freeAssetDrops.find(function (a) {
          return a.id === assetId;
        });
      }

      asset = asset || algoliaAsset;

      if (!asset) {
        this.context.router.push({ pathname: "/404", state: { modal: false } });
      }

      var resolution = void 0;
      var assetType = asset.type || asset.categories[0];
      if (assetType && settings[assetType]) {
        resolution = asset.version === 2 && assetType.toLowerCase().startsWith("3d") ? settings["3dplant"].resolution : settings[assetType].resolution;
      }
      var assetName = (0, _utils.capitalize)((0, _utils.getAssetName)(asset));
      var backgroundImages = null;
      var fullScreenBackgroundImages = null;

      var imageNames = null;
      var resolutions = null;
      var backgroundImageThumb = void 0;
      var thumbImages = null;

      if (asset.previews.images && asset.previews.images[0] && asset.previews.images[0].tags) {
        if (__SERVER__) {
          var siteImage = (0, _utils.pickPreviewsForAsset)(assetType, 800, 800, asset.previews.images).retArray[0];
          return _react2.default.createElement(
            _components.AppSideEffects,
            { documentTitle: assetName, documentImage: siteImage },
            _react2.default.createElement(
              "div",
              { className: loadingSpinnerStyles },
              _react2.default.createElement(_Preloader2.default, null)
            )
          );
        }
        var devicePixelRatio = window.devicePixelRatio;

        var screenWidth = window.screen.width * devicePixelRatio;
        var screenHeight = window.screen.height * devicePixelRatio;

        var previewImages = (0, _utils.pickPreviewsForAsset)(assetType, screenWidth, screenHeight, asset.previews.images);
        fullScreenBackgroundImages = previewImages.retArray;

        imageNames = previewImages.nameArray;
        resolutions = previewImages.resolutions;
        var popupWidth = window.innerWidth - 150;
        if (popupWidth > 1920) {
          popupWidth = 1920;
        }
        popupWidth *= devicePixelRatio;

        var popupHeight = window.innerHeight - 250;

        if (popupHeight > 800) {
          popupHeight = 800;
        }
        popupHeight *= devicePixelRatio;
        previewImages = (0, _utils.pickPreviewsForAsset)(assetType, popupWidth, popupHeight, asset.previews.images);
        backgroundImages = previewImages.retArray;
      }
      if (algoliaAsset) {
        asset.previews.relativeSize = algoliaAsset.previews.relativeSize;
        if (window.devicePixelRatio > 1) {
          backgroundImageThumb = algoliaAsset.previews.images.thumbGridRetinaJpg || algoliaAsset.previews.images.thumbRetinaJpg;
        } else {
          backgroundImageThumb = algoliaAsset.previews.images.thumbGridJpg || algoliaAsset.previews.images.thumbJpg;
        }
      }

      var currentQuota = _ramda2.default.pathOr(0, ["quota", "currentQuota"])(user);
      var maxAssetResolution = (0, _utils.getMaxAssetResolution)(asset);

      var isAcquired = loggedIn && !!asset.acl;
      var isFav = loggedIn && favorites && favorites.indexOf(assetId) != -1;
      var isActiveSubscription = _ramda2.default.pathOr(false, ["subscription", "isActive"], user);
      var canAcquireAssetsAfterExpiry = _ramda2.default.pathOr(false, ["subscription", "canAcquireAssetsAfterExpiry"], user);

      var addPointsAllowed = user.subscription && user.subscription.doesGetCharged === true && (0, _utils2.isAddPointsAllowed)(user.subscription.planId);

      var isFullAssetLoaded = !!fullAssets[assetId];
      var accessResolution = maxAssetResolution;
      var disableDownload = false;

      var subscriptionResolution = user.subscription && user.subscription.accessResolution;

      if (loggedIn) {
        if (!!subscriptionResolution) {
          accessResolution = Math.min(maxAssetResolution, subscriptionResolution);
        }

        if (asset.acl) {
          accessResolution = Math.min(asset.acl.resolution, maxAssetResolution);
        }
      }

      var isFree = asset.points === 0;
      if (isFree) {
        accessResolution = Math.min(resolution, maxAssetResolution);
      }

      var userFreeAssets = user && user.drops && user.drops.assetIds && user.drops.assetIds.length ? user.drops.assetIds : [];
      var isUserFreeDrop = userFreeAssets && !!userFreeAssets.find(function (a) {
        return a == assetId;
      });

      var settingsSummary = loggedIn ? Math.min(resolution, accessResolution) : Math.min(resolution, maxAssetResolution);

      var showScale = false;
      var scale = { height: 0, width: 0, length: 0 };
      var is3d = assetType.toLowerCase() === "3d" && asset.version !== 2;
      var length = (0, _utils.getMetaProp)(asset, "length");
      var height = (0, _utils.getMetaProp)(asset, "height");
      var width = (0, _utils.getMetaProp)(asset, "width");

      if (is3d) {
        if (!_underscore2.default.isEmpty(length) && !_underscore2.default.isEmpty(height) && !_underscore2.default.isEmpty(width)) {
          showScale = true;
          scale = {
            width: Math.max(parseFloat(length), parseFloat(width)),
            height: parseFloat(height)
          };
        }
      }

      var downloadWarning = _ramda2.default.and(_ramda2.default.gt(settingsSummary, maxAssetResolution), "Max available resolution: " + maxAssetResolution) || "";

      var overlayLODs = [];
      var overlayReferences = [];
      var overlayDescription = "";
      if (isFullAssetLoaded) {
        overlayReferences = _underscore2.default.compact([].concat(asset.references));
        overlayDescription = asset.description || "";

        if (is3d) {
          overlayLODs = _underscore2.default.values(asset.meshes.filter(function (mesh) {
            return mesh.type === "lod";
          }).map(function (mesh) {
            return mesh.tris;
          }));
        }

        if (loggedIn && manage && isLoggedInUserAnAssetManufacturer) {
          this.manufactureManage();
        }
      }
      overlayLODs.sort(function (a, b) {
        return a - b;
      });
      var isDownloading = this.props.downloadRequesting || this.props.acquiringAsset;
      var dlProgress = 0;
      if (isDownloading) {
        dlProgress = 0.01;
      }

      var maxVariant = void 0;
      if (asset.models) {
        maxVariant = 0;
        asset.models.map(function (model) {
          if (model.variation) {
            if (maxVariant < model.variation) {
              maxVariant = model.variation;
            }
          }
        });
      }

      var platform = this.state.platform;


      var bridgeDownloadUrl = _utils.bridgeBuilds[platform.toLowerCase()];
      var mailTo = encodeURI("mailto:?subject=Quixel Bridge Download Link&body=Note to self: Remember to download Quixel Bridge the next time I am on my desktop machine.\n" + "Here are the download links —\n\n" + "Windows: " + _utils.bridgeBuilds.windows + "\n\n" + "Mac: " + _utils.bridgeBuilds.mac + "\n\n" + "Linux: " + _utils.bridgeBuilds.linux + "\n\n");

      if (__CLIENT__ && (0, _utils.detectMobileAndTablet)()) {
        bridgeDownloadUrl = mailTo;
      }

      var toolTip = _react2.default.createElement(
        "div",
        { className: toolTipContainer },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: title },
            "Download this asset 4 times faster using Quixel Bridge!"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: subContainer },
          _react2.default.createElement(_TextButtonWithIcon2.default, {
            right: true,
            iconType: "download",
            iconColor: _css.pallets.blue_primary,
            className: links,
            mode: "small-normal",
            label: "Download Bridge",
            to: "/bridge"
          })
        )
      );

      var tagsWithoutArchViz = _ramda2.default.without(["archviz"], asset.tags);
      var tags = tagsWithoutArchViz.map(function (t) {
        return {
          name: t,
          to: "/megascans/library?search=" + t
        };
      });
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: assetName,
          documentImage: backgroundImageThumb || backgroundImages[0]
        },
        _react2.default.createElement(_AssetPopup2.default, (_React$createElement = {
          variations: maxVariant && maxVariant,
          isMegascan: true,
          assetId: assetId,
          images: backgroundImages,
          fullScreenImages: fullScreenBackgroundImages,
          imageNames: imageNames,
          imageResolutions: resolutions,
          imageThumb: backgroundImageThumb,
          loggedIn: loggedIn,
          name: assetName,
          type: assetType,
          physicalSize: asset.physicalSize,
          settingsSummary: "" + (isFullAssetLoaded ? settingsSummary : ""),
          points: asset.points,
          references: asset.references,
          wallet: currentQuota,
          isPopup: this.props.isPopup,
          isActiveSubscription: isActiveSubscription,
          canAcquireAssetsAfterExpiry: canAcquireAssetsAfterExpiry,
          loaded: isFullAssetLoaded,
          isAcquired: isAcquired,
          isScatter: (0, _utils.isScatter)(asset),
          isAssembly: !!(0, _utils.isAssembly)(asset),
          isOpen: (0, _utils.isOpen)(asset),
          isClosed: (0, _utils.isClosed)(asset),
          showScale: showScale,
          scale: scale,
          relativeSize: asset.previews.relativeSize,
          isFavorited: isFav,
          categories: asset.categories,
          tags: tags,
          downloadWarning: downloadWarning,
          disableDownload: disableDownload,
          isDownloading: this.props.downloadRequesting || this.props.acquiringAsset,
          dlProgress: dlProgress,
          onDownloadClick: asset.acl || asset.points === 0 ? this.handleDownloadClick : this.handleAcquireClick,
          onDownloadSettingsClick: this.handleSettingsClick,
          manufactureManage: this.manufactureManage,
          onFavoriteToggle: this.handleFavoriteToggle,
          showAddPoints: addPointsAllowed,
          manufacturer: manufacturer,
          isLoggedInUserAnAssetManufacturer: isLoggedInUserAnAssetManufacturer,
          lods: overlayLODs
        }, (0, _defineProperty3.default)(_React$createElement, "references", overlayReferences), (0, _defineProperty3.default)(_React$createElement, "description", overlayDescription), (0, _defineProperty3.default)(_React$createElement, "isShowDetailsOpen", this.state.isOpen), (0, _defineProperty3.default)(_React$createElement, "onShowDetailsClick", this.onShowDetailsClick), (0, _defineProperty3.default)(_React$createElement, "onHideDetailsClick", this.onHideDetailsClick), (0, _defineProperty3.default)(_React$createElement, "isUserFreeDrop", isUserFreeDrop), (0, _defineProperty3.default)(_React$createElement, "onReportIssueClick", function onReportIssueClick() {
          return _this3.context.dialogs.custom(_react2.default.createElement(_components.ReportAssetPopupContainer, {
            assetId: assetId,
            is3d: assetType.toLowerCase().startsWith("3d"),
            email: loggedIn ? user.email : "Anonymous",
            initialValues: { comment: "" }
          }));
        }), (0, _defineProperty3.default)(_React$createElement, "onAddPointsClick", function onAddPointsClick() {
          return _this3.context.dialogs.custom(_react2.default.createElement(_components.AddPointsPopup, null));
        }), (0, _defineProperty3.default)(_React$createElement, "onChildRef", childReference), (0, _defineProperty3.default)(_React$createElement, "toolTip", toolTip), (0, _defineProperty3.default)(_React$createElement, "isUnlimited", !!_ramda2.default.pathOr(0, ["quota", "isUnlimited"], user)), _React$createElement))
      );
    }
  }]);
  return AssetPopupContainer;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = AssetPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AssetPopup/AssetPopup.jsx
// module id = 2422
// module chunks = 0